"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _peractoUi = require("@peracto/peracto-ui");

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _faPlusCircle = require("@fortawesome/pro-regular-svg-icons/faPlusCircle");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var InputRows = function InputRows(_ref) {
  var label = _ref.label,
      description = _ref.description,
      name = _ref.name,
      fields = _ref.fields;
  var inputs = [];
  var defaultRow = {};

  for (var _i = 0, _Object$entries = Object.entries(fields); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        val = _Object$entries$_i[1];

    inputs.push(_objectSpread({
      name: key
    }, val));
    defaultRow[key] = '';
  }

  var sortedInputs = (0, _sortBy["default"])(inputs, ['display_order']);
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name
  }, function (_ref2) {
    var form = _ref2.form,
        field = _ref2.field;
    return /*#__PURE__*/_react["default"].createElement(_formik.FieldArray, {
      name: name
    }, function (_ref3) {
      var push = _ref3.push,
          remove = _ref3.remove;
      var values = field === null || field === void 0 ? void 0 : field.value;
      var error = (0, _formik.getIn)(form.errors, name);

      if (error && (0, _isString["default"])(error)) {
        var errorFieldName = label ? label : 'This';
        error = error.replace(field.name, errorFieldName);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "d-flex flex-column"
      }, label && /*#__PURE__*/_react["default"].createElement("label", {
        className: description ? 'mb-0' : ''
      }, label), description && /*#__PURE__*/_react["default"].createElement("p", {
        className: "help-text text-grey ".concat(error ? 'mb-0' : '')
      }, description), error && (0, _isString["default"])(error) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-2"
      }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Error, {
        error: error,
        name: name
      })), /*#__PURE__*/_react["default"].createElement("table", {
        className: "table table-sm"
      }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, sortedInputs === null || sortedInputs === void 0 ? void 0 : sortedInputs.map(function (input) {
        return /*#__PURE__*/_react["default"].createElement("th", {
          key: "".concat(input.name, "_th")
        }, input.label);
      }), /*#__PURE__*/_react["default"].createElement("th", {
        className: "text-right"
      }, "Remove"))), /*#__PURE__*/_react["default"].createElement("tbody", null, (values === null || values === void 0 ? void 0 : values.length) > 0 && values.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: "".concat(name, "_").concat(index),
          "data-id": "".concat(name, "_").concat(index)
        }, sortedInputs === null || sortedInputs === void 0 ? void 0 : sortedInputs.map(function (input) {
          return /*#__PURE__*/_react["default"].createElement("td", {
            key: "".concat(input.name, "_").concat(index)
          }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, _extends({
            name: "".concat(name, ".").concat(index, ".").concat(input.name),
            type: input.type
          }, input === null || input === void 0 ? void 0 : input.options)));
        }), /*#__PURE__*/_react["default"].createElement("td", {
          className: "text-right"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-sm btn-danger",
          onClick: function onClick() {
            remove(index, 1);
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _faTrash.faTrash
        }))));
      }))), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        role: "button",
        className: "btn btn-primary mb-2 align-self-end",
        onClick: function onClick() {
          return push(defaultRow);
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faPlusCircle.faPlusCircle,
        className: "mr-2"
      }), "Add a value"));
    });
  });
};

InputRows.displayName = 'InputRows';
InputRows.propTypes = {
  label: _propTypes["default"].string,
  description: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  fields: _propTypes["default"].object.isRequired
};
var _default = InputRows;
exports["default"] = _default;